import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import s from 'components/bolt/header/header.sss';


export default class Header extends BaseComp.default {

	shouldHideActionBtn(actionData, showtimes, homeEnt, pressKit) {
		return actionData.tag === 'backToListMode' ? true : super.shouldHideActionBtn?.(actionData, showtimes, homeEnt, pressKit);
	}

	renderHeaderLogo(logoData = this.props.appData?.header?.powsterHeader?.logo) {
		const activePage = this.props.activePage;
		const pages = this.props.appData?.pages || {};
		let pageData = pages[activePage];
		if (pageData.group) {
			pageData = pages[pageData.group] || pageData;
		}
		if (logoData && pageData.customHeaderLogo) {
			logoData = {
				...logoData,
				src: pageData.customHeaderLogo,
			};
		}
		return super.renderHeaderLogo(logoData);
	}

	renderExtraActions() {}

	renderPersistentButton() {}

	render(props) {
		const baseJSX = super.render(props);
		const headerContainer = baseJSX.children[1];
		const showtimesOpen = Store.get().showtimes?.showtimesOpen;
		if (showtimesOpen) {
			headerContainer.attributes.class += ` ${s.showtimesOpen}`;
		}
		return baseJSX;
	}
}
